<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="main-toolbar cf-flex-row cf-justify-content-end" color="primary">
  <div class="left-side">
    <span class="title"
      >{{ 'UI.Common.Breadcrumb.Products' | translate }}:
      {{ (multiEditEnabled$ | async) ? ('UI.Common.Action.MultiEdit' | translate) : ('UI.Common.Action.Edit' | translate) }}</span
    >
  </div>
  <app-project-file-download></app-project-file-download>
</mat-toolbar>
<div class="main-content-with-sidebar">
  <div *ngIf="showLoading$ | async" class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <div *ngIf="(showLoading$ | async) === false">
    <div *ngIf="projectEntity$ | async as projectEntity">
      <mat-sidenav-container autosize class="product-drawer-container" [ngClass]="{ 'left-open': (sidebarOpened$ | async) }">
        <mat-sidenav
          class="left"
          [ngClass]="{ opened: (sidebarOpened$ | async), closed: (sidebarOpened$ | async) === false }"
          #drawer
          mode="side"
          disableClose="true"
          opened="true"
          [ngStyle]="{ 'max-height': sidenavSettings.height + 'px' }"
          [fixedInViewport]="sidenavSettings.fixed"
          [fixedTopGap]="sidenavSettings.top"
          [fixedBottomGap]="sidenavSettings.bottom"
          disableClose="true"
        >
          <div [ngStyle]="{ 'max-height': sidenavSettings.maxHeightProductTree + 'px' }">
            <app-product-tree
              *ngIf="projectTreeEntity$ | async as projectTree"
              [projectEntity]="projectTree"
              [entityTypeNames]="entityTypeNames$ | async"
              [messageFilter]="isNotHoodLineMessage"
            ></app-product-tree>
          </div>

          <div class="cf-flex-auto"></div>
          <div class="divider-container" *ngIf="sidebarOpened$ | async">
            <mat-divider></mat-divider>
          </div>

          <div class="product-messages-container" *ngIf="sidebarOpened$ | async">
            <app-product-messages [messageFilter]="isNotHoodLineMessage"></app-product-messages>
          </div>
        </mat-sidenav>
        <mat-sidenav
          *ngIf="showInSidebar"
          class="right"
          [ngClass]="{ opened: (sidebarRightOpened$ | async), closed: (sidebarRightOpened$ | async) === false }"
          mode="side"
          position="end"
          opened="true"
          [ngStyle]="{ 'max-height': sidenavSettings.height + 'px' }"
          [fixedInViewport]="sidenavSettings.fixed"
          [fixedTopGap]="sidenavSettings.top"
          [fixedBottomGap]="sidenavSettings.bottom"
          disableClose="true"
        >
          <ng-container *ngIf="show3DStatus$ | async as status">
            <app-product-visual-editor
              *ngIf="status.show3d"
              [projectEntity]="projectEntity"
              (entityClicked)="entity3DClicked($event)"
              [errorHighlightIds]="panelErrorIds$ | async"
            >
            </app-product-visual-editor>
            <div *ngIf="!status.show3d" class="no-3d">
              <p>{{ status.noShowReasonTextId | translate }}</p>
            </div>
          </ng-container>
        </mat-sidenav>
        <div class="product-content">
          <app-product-editor
            *ngIf="(multiEditEnabled$ | async) === false"
            [projectEntity]="projectEntity"
            [groupFilter]="shouldRenderGroupFilter"
          ></app-product-editor>

          <app-multi-edit-product-editor
            *ngIf="multiEditEnabled$ | async"
            [entityTypeNames]="entityTypeNames$ | async"
          ></app-multi-edit-product-editor>

          <div *ngIf="!showInSidebar">
            <app-product-visual-editor
              *ngIf="(show3DStatus$ | async).show3d"
              [projectEntity]="projectEntity"
              (entityClicked)="entity3DClicked($event)"
              [errorHighlightIds]="panelErrorIds$ | async"
            ></app-product-visual-editor>
          </div>

          <div *ngIf="showHoodLineButton(projectEntity) && (multiEditEnabled$ | async) === false" class="form-button line-button">
            <button mat-flat-button color="primary" (click)="hoodLinesButtonClicked()">
              {{ 'UI.Common.ConfigureHoodLines' | translate }}
            </button>
          </div>
        </div>
      </mat-sidenav-container>
    </div>
  </div>
</div>
